import {KeyboardDatePicker} from "@material-ui/pickers";
import {Grid, withStyles} from "@material-ui/core";
import {Field} from "formik";
import moment from "moment";
import * as PropTypes from "prop-types";
import React from "react";
import style from "./styles";
import {TextFieldNumber} from './TextFieldNumber';
import is from 'is_js';
import {IconCalendario} from '../icons/MateraIcons';

const inputDateBuilder = (props) => {
    const {classes, fieldSchema: schema} = props;
    return <Grid item {...schema.sizes}>
        <Field name={schema.field} {...props} required={schema.isRequired} >{
            ({field, form}) => {
                const {onBlur, onChange, ...other} = field;

                function onKeydown(e) {
                    if(['ArrowUp', 'ArrowDown'].includes(e.key)){
                        e.preventDefault()
                        if(e.target.value.includes('_') || is.empty(e.target.value))
                            return
                        const addSub = e.key === 'ArrowUp' ? 'add' : 'subtract';
                        if(e.ctrlKey) {
                            return form.setFieldValue(other.name, moment(e.target.value, schema.format)[addSub](1, 'month'))
                        }
                        return form.setFieldValue(other.name, moment(e.target.value, schema.format)[addSub](1, 'day'))
                    }
                }

                async function handleBlur(e) {
                    const parsedValue = moment(e.target.value, schema.format);
                    form.setFieldValue(other.name, parsedValue);
                    if (typeof schema.onBlur === 'function') {
                        try {
                            await schema.onBlur(e, parsedValue, form);
                        } catch (err) {
                            console.error(err);
                        }
                    }
                }

                async function handleChange(value) {
                    const parsedValue = moment(value);
                    form.setFieldValue(other.name, parsedValue);
                    if (typeof schema.onChange === 'function') {
                        try {
                            await schema.onChange(parsedValue, form);
                        } catch (err) {
                            console.error(err);
                        }
                    }
                }

                return <KeyboardDatePicker
                    {...field}
                    disableToolbar
                    clearable="true"
                    variant="inline"
                    format={schema.format}
                    label={schema.label}
                    disabled={schema.disabled}
                    className={classes.margin}
                    value={field.value}
                    invalidDateMessage={'Data Inválida'}
                    autoOk
                    autoComplete={'off'}
                    TextFieldComponent={TextFieldNumber}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    openTo={schema.openTo ?? null}
                    views={schema.views ?? ['date']}
                    onKeyDown={onKeydown}
                    keyboardIcon={<IconCalendario size={18}/>}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                        tabIndex: -1,
                        size: 'small'
                    }}
                />
            }
        }
        </Field>
    </Grid>;
};


inputDateBuilder.propTypes = {
    classes: PropTypes.any,
    data: PropTypes.any
};

export default withStyles(style)(inputDateBuilder);
